/**
 * Event Services
 * Services for event management operations
 */
// Export all service classes
export { EventService } from './EventService';
export { EventTypeService } from './EventTypeService';
export { EventStatusService } from './EventStatusService';
export { EventVendorStatusService } from './EventVendorStatusService';
export { EventVendorRegistrationService } from './EventVendorRegistrationService';
export { EventVendorSettingService } from './EventVendorSettingService';
export { ShopService } from './ShopService';
export { EventAdminService } from './EventAdminService';
export { EventSourceService } from './EventSourceService';
export { EventCalendarService } from './EventCalendarService';
export { EventLinkService } from './EventLinkService';
export { EventTagService } from './EventTagService';
export { EventRuleService } from './EventRuleService';
export { EventLearningService } from './EventLearningService';
export { EventPlaybookService } from './EventPlaybookService';
export { EventPlanService } from './EventPlanService';
// Import for factory function
import { EventService } from './EventService';
import { EventTypeService } from './EventTypeService';
import { EventStatusService } from './EventStatusService';
import { EventVendorStatusService } from './EventVendorStatusService';
import { EventVendorRegistrationService } from './EventVendorRegistrationService';
import { EventVendorSettingService } from './EventVendorSettingService';
import { ShopService } from './ShopService';
import { EventAdminService } from './EventAdminService';
import { EventSourceService } from './EventSourceService';
import { EventCalendarService } from './EventCalendarService';
import { EventLinkService } from './EventLinkService';
import { EventTagService } from './EventTagService';
import { EventRuleService } from './EventRuleService';
import { EventLearningService } from './EventLearningService';
import { EventPlaybookService } from './EventPlaybookService';
import { EventPlanService } from './EventPlanService';
/**
 * Create all event services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all event services
 */
export function createEventServices(http, config) {
    return {
        event: new EventService(http, config),
        eventType: new EventTypeService(http, config),
        eventStatus: new EventStatusService(http, config),
        eventVendorStatus: new EventVendorStatusService(http, config),
        eventVendorRegistration: new EventVendorRegistrationService(http, config),
        eventVendorSetting: new EventVendorSettingService(http, config),
        shop: new ShopService(http, config),
        eventAdmin: new EventAdminService(http, config),
        eventSource: new EventSourceService(http, config),
        eventCalendar: new EventCalendarService(http, config),
        eventLink: new EventLinkService(http, config),
        eventTag: new EventTagService(http, config),
        eventRule: new EventRuleService(http, config),
        eventLearning: new EventLearningService(http, config),
        eventPlaybook: new EventPlaybookService(http, config),
        eventPlan: new EventPlanService(http, config),
    };
}
//# sourceMappingURL=index.js.map